import { Component, Input, OnInit } from '@angular/core'
import { AffairModel } from '../../../../../core/models/affair.model'
import { CardModule } from 'primeng/card'
import { DividerModule } from 'primeng/divider'
import { KeyValuePipe, TitleCasePipe } from '@angular/common'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-affair-informations',
  standalone: true,
  templateUrl: './affair-informations.component.html',
  styleUrls: ['./affair-informations.component.scss'],
  imports: [
    CardModule,
    DividerModule,
    TitleCasePipe,
    KeyValuePipe,
    ButtonModule,
    TooltipModule,
  ],
})
export class AffairInformationsComponent implements OnInit {
  @Input() affair: any

  constructor() {}

  ngOnInit() {}

  getHeaderTemplate(erpSource: string): string {
    return 'Informations ' + '<i class="tll fa-logo-' + erpSource + '"></i>'
  }

  navigateToEros(): void {
    if (!this.affair) return

    const erpSource = this.affair.erpSource
    const srcErpEntry = this.affair.srcErp?.find(
      (entry: any) => entry.society === erpSource
    )
    const affairId = srcErpEntry?.value?.id

    console.log('affair', this.affair)
    console.log(
      'Navigating to Eros with ERP Source:',
      erpSource,
      'Affair ID:',
      affairId
    )

    if (!affairId) return

    if (erpSource === 'abm') {
      window.open(
        environment.abmUrl + 'affairs/' + affairId + '/show',
        '_blank'
      )
    } else if (erpSource === 'nrj') {
      window.open(
        environment.nrjUrl + 'affairs/' + affairId + '/show',
        '_blank'
      )
    }
  }
}
